/**
 * Registers the casino push notification service worker.
 *
 * Must be called on app mount. Does nothing in browsers that do not
 * support the Service Worker API, so it is always safe to call.
 */
export function registerSw(): void {
    if (!('serviceWorker' in navigator)) {
        return;
    }

    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/sw.js', { scope: '/' })
            .then(() => {
                // Service worker registered successfully
            })
            .catch((error) => {
                if (import.meta.env.DEV) {
                    console.error('[SW] Service worker registration failed:', error);
                }
            });
    });
}
